import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class ForgotPssService {
  constructor(private http: HttpClient) {}
  postLogin(formData: any): Observable<any> {
    // const data = JSON.stringify(formData.value);
    const data = {
      email: formData.email,
    };
  
    return this.http.post(environment.serverUrl + 'forgot_password', data);

  }
}

